export default {
  getNotification (state) {
    return state.notifications
  },
  getLastPage (state) {
    return state.last_page
  },
  getCurrentPage (state) {
    return state.current_page
  },
  getNoUnRead (state) {
    return state.noUnRead
  }
}



// WEBPACK FOOTER //
// ./src/store/module/notification/getters.js